import { donutAssets } from '../constants/assets'
import type { ServiceLeader, ServiceSlice } from '../types'
import type { DesignFrame } from '../utils/geometry'

/** Design-space size of the Booking Services card in Figma. */
export const servicesFrame: DesignFrame = { width: 317, height: 361 }

/** Donut ring bounds in design-space px. */
export const servicesRing = { x: 50.73, y: 86.45, width: 217.884, height: 218.248 }

export const servicesDonutCenter = {
  cx: servicesRing.x + servicesRing.width / 2,
  cy: servicesRing.y + servicesRing.height / 2,
  outerR: 82,
  innerR: 47,
  strokeWidth: 35,
}

export const servicesTotalCount = 1208

export const servicesTotal = {
  caption: { label: 'Total', x: 145, y: 179 },
  value: { label: String(servicesTotalCount), x: 143.22, y: 195.89 },
}

/** Leader lines connecting each segment to its label. */
export const servicesLeaders: ServiceLeader[] = [
  { id: 'ski', src: donutAssets.leaderSki, x: 78.33, y: 151.45, width: 19.111, height: 67.555, bleed: '0 -5.08% -0.12% 0' },
  { id: 'day', src: donutAssets.leaderDay, x: 117.44, y: 89.22, width: 16.89, height: 39.555, bleed: '0 0 0 -5.26%', mirrored: true },
  { id: 'airport', src: donutAssets.leaderAirport, x: 173.45, y: 98.11, width: 31.196, height: 58.475, bleed: '0' },
  { id: 'others', src: donutAssets.leaderOthers, x: 218.78, y: 241.22, width: 16, height: 39.111, bleed: '0 0 0 -5.56%' },
  { id: 'private', src: donutAssets.leaderPrivate, x: 88.11, y: 260.78, width: 39.111, height: 16, bleed: '-5.56% 0 0 0' },
]

/** Slice order follows the donut clockwise from the top. Colors match the Figma export. */
export const servicesSlices: ServiceSlice[] = [
  {
    id: 'day',
    label: 'Day Trips',
    share: '15%(125)',
    percent: 15,
    count: 125,
    color: '#C1C1EC',
    label_x: 58.78,
    label_y: 84.78,
    share_x: 58.78,
    share_y: 102.55,
  },
  {
    id: 'airport',
    label: 'Airport Transfer',
    share: '25%(525)',
    percent: 25,
    count: 525,
    color: '#759DB7',
    label_x: 207.22,
    label_y: 92.78,
    share_x: 229.45,
    share_y: 111.44,
  },
  {
    id: 'others',
    label: 'Others',
    share: '10%(62)',
    percent: 10,
    count: 62,
    color: '#FFFFFF',
    label_x: 239.22,
    label_y: 270.55,
    share_x: 244.55,
    share_y: 288.33,
  },
  {
    id: 'private',
    label: 'Private Van Tours',
    share: '30%(349)',
    percent: 30,
    count: 349,
    color: '#312119',
    label_x: 21.45,
    label_y: 280.33,
    share_x: 35.67,
    share_y: 297.22,
  },
  {
    id: 'ski',
    label: 'Ski Transfer',
    share: '20%(187)',
    percent: 20,
    count: 187,
    color: '#F6F642',
    label_x: 9,
    label_y: 145.22,
    share_x: 17,
    share_y: 163,
  },
]
